<template>
  <div class="fixed w-full top-0 z-40">
    <div class="w-full z-50 relative bg-primary">

      <div class="container mx-auto flex items-center h-12 md:h-16 lg:h-20">
        <div class="w-1/3 lg:w-1/5 pl-4">
          <a href="/" title="Whittaker Home"><img src="/img/whittaker_logo_white.svg" alt="Whittaker Logo"/></a>
        </div>
        <main-navigation class="hidden lg:block w-3/5"></main-navigation>
        <search class="hidden lg:block w-1/5 pr-4"></search>
      </div>
    </div>
    <div class="hidden lg:block w-full z-40 absolute">
      <secondary-navigation></secondary-navigation>
    </div>
  </div>
</template>
<script>
import {mapMutations} from "vuex"
import MainNavigation from "@/components/header/MainNavigation"
import SecondaryNavigation from "@/components/header/SecondaryNavigation"
import Search from "@/components/search-form/Search";

export default {
  components: {
    MainNavigation,
    SecondaryNavigation,
    Search
  },
  props: {
    navData: {type: Array, required: true}
  },
  methods: {
    ...mapMutations('navigation', [
      'setNavData'
    ])
  },
  mounted() {
    this.setNavData(this.navData)
  }
}
</script>
